// src/components/Footer.jsx
import React from "react";
import Momentsia_logo from "../images/Momentsia _logo.png";

const T1 = "#0ecfb0";
const NAVY = "#0d1b2a";

const footerQuickLinks = ["Home", "Talent", "About", "Event Gallery", "Testimonials", "Contact"];
const footerServices = ["Event Planning", "Creative Design", "Vendor Management", "Catering", "Entertainment Booking", "Photography", "Talent Management"];

// Logo Component
const MomentsiaLogo = ({ light = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
    <img src={Momentsia_logo} alt="Momentsia" style={{ height: 48, width: "auto", objectFit: "contain" }} />
  </div>
);

export default function Footer() {
  return (
    <footer style={{ background: NAVY, color: "#ccc", padding: "60px 24px 0", borderTop: `3px solid ${T1}` }}>
      <style>{`
        .fl:hover{color:${T1}!important;}
        .sb:hover{background:${T1}!important;color:#fff!important;}
      `}</style>
      
      <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 54, paddingBottom: 52 }}>
        {/* Brand Column */}
        <div>
          <MomentsiaLogo light />
          <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 13.5, lineHeight: 1.75, marginTop: 16, marginBottom: 24 }}>
            Kolkata's premier event management & talent agency, delivering unforgettable experiences.
          </p>
          <h4 style={{ color: "rgba(255,255,255,0.8)", fontWeight: 700, fontSize: 14, margin: "0 0 14px" }}>Follow Us</h4>
          <div style={{ display: "flex", gap: 8 }}>
            {["f", "𝕏", "◉", "▶"].map(ic => (
              <a key={ic} href="#" className="sb" style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, textDecoration: "none", background: "rgba(255,255,255,0.08)", width: 36, height: 36, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>{ic}</a>
            ))}
          </div>
        </div>

        {/* Quick Links Column */}
        <div>
          <h4 style={{ color: "#fff", fontWeight: 700, fontSize: 15, marginBottom: 20, borderBottom: `2px solid ${T1}`, display: "inline-block" }}>Quick Links</h4>
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {footerQuickLinks.map(l => (
              <li key={l} style={{ marginBottom: 11 }}>
                <a href={l === "Home" ? "/" : l === "Talent" ? "/talent-management" : l === "Event Gallery" ? "/event-photo-gallery" : `/${l.toLowerCase()}`} className="fl" style={{ color: "#7ab5b0", textDecoration: "none", fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ color: T1 }}>›</span>{l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services Column */}
        <div>
          <h4 style={{ color: "#fff", fontWeight: 700, fontSize: 15, marginBottom: 20, borderBottom: `2px solid ${T1}`, display: "inline-block" }}>Services</h4>
          <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {footerServices.map(s => (
              <li key={s} style={{ marginBottom: 11 }}>
                <a href="/services" className="fl" style={{ color: "#7ab5b0", textDecoration: "none", fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ color: T1 }}>›</span>{s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Column */}
        <div>
          <h4 style={{ color: "#fff", fontWeight: 700, fontSize: 15, marginBottom: 20, borderBottom: `2px solid ${T1}`, display: "inline-block" }}>Contact Us</h4>
          <div style={{ marginBottom: 16 }}>
            <p style={{ color: T1, fontWeight: 700, fontSize: 11, textTransform: "uppercase", marginBottom: 4 }}>Corporate Office</p>
            <p style={{ color: "#7ab5b0", fontSize: 13, lineHeight: 1.6, margin: 0 }}>
              Momentsia P S Abacus - 703, 7th Floor, NH12, Action Area IIE, Newtown, Kolkata - 700161
            </p>
          </div>
          <div style={{ marginTop: 18, display: "flex", flexDirection: "column", gap: 10 }}>
            <a href="tel:+918100364941" style={{ color: "#7ab5b0", textDecoration: "none", fontSize: 13.5, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: T1 }}>📞</span> +91 81003 64941
            </a>
            <a href="mailto:info@momentsia.com" style={{ color: "#7ab5b0", textDecoration: "none", fontSize: 13.5, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: T1 }}>✉</span> info@momentsia.com
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div style={{ borderTop: "1px solid rgba(14,207,176,0.12)", padding: "20px 0", textAlign: "center" }}>
        <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 13, margin: 0 }}>
          Copyright © 2024 Momentsia – All rights reserved. | Event Management & Talent Agency
        </p>
      </div>
    </footer>
  );
}